"use client";
import { useRef } from "react";
import { useEffect } from "react";
import Banner from "@/components/BrandDetail/Banner";
import Category from "@/components/BrandDetail/Category";
import ContactSpecialist from "@/components/BrandDetail/ContactSpecialist";
import FindShowroom from "@/components/BrandDetail/FindShowroom";
import VideoSection from "@/components/BrandDetail/Video";
import SEOContent from "@/components/BrandDetail/SEOContent";
import BrandAdBanner from "@/assets/images/brand-ad-banner.png";
import BrandAdBannerMobile from "@/assets/images/brand-ad-banner-mobile.png";
import { useDispatch } from "react-redux";
import Link from "next/link";
import Image from "next/image";
import CustomBreadcrumb from "../CustomBreadcrumbs/customBreadcrumbs";
import FullSuitBannerWeb from "@/assets/images/static/brands/Cafe/Full-Suite-Savings_Desktop.png"
import FullSuitBannerMobile from "@/assets/images/static/brands/Cafe/Full-Suite-Savings_Mobile.png"
import ElectroluxLaundryWeb from "@/assets/images/static/brands/Electrolux/ElectroluxLaundry_web.png"
import ElectroluxLaundryMobile from "@/assets/images/static/brands/Electrolux/ElectroluxLaundry_mobile.png"
import BoschBannerDesktop from "@/assets/images/static/brands/Bosch/BoschFreeCookwareSet_Desktop.png"
import BoschBannerMobilep from "@/assets/images/static/brands/Bosch/BoschFreeCookwareSet_Mobile.png"
import BoschEspressoMachineBannerDesktop from "@/assets/images/static/brands/Bosch/BoschEspressoMachineBanner.jpg"
import BoschEspressoMachineBannerMobile from "@/assets/images/static/brands/Bosch/BoschEspressoMachineBanner_Mobile.png"

import LoyaltyProgramWeb from "@/assets/images/static/brands/Cafe/Loyalty-Program_Web.png"
import LoyaltyProgramMobile from "@/assets/images/static/brands/Cafe/Loyalty-Program_Mobile.png"

const BrandDetail = ({ slug }) => {
   const contactRef = useRef(null);
  
    const scrollToContact = () => {
      if (contactRef.current) {
        const elementPosition = contactRef.current.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementPosition - 150, // scroll 400px down from the element
          behavior: 'smooth',
        });
      }
    };

  const dispatch = useDispatch();
  let brandTitle = slug
    .replace(/-/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join("_");

  useEffect(() => {
    if (brandTitle === "Speed_Queen") {
      // Inject Meta Pixel only for Speed_Queen
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

      window.fbq("init", "948167505354989");
      window.fbq("track", "PageView");
    }
  }, [brandTitle]);

  if (!brandTitle) return <div></div>;


  const updateBreadcrumb = (breadcrumb) => {
    dispatch(AddNewBreadcrum(breadcrumb));
  };
  return (
    <div>
      <div className="container-fuild max-w-full ">
        <CustomBreadcrumb />
      </div>
      <Banner brandName={brandTitle} />
       
      {["Cove", "Sub_Zero", "Wolf"].includes(brandTitle) ? (
        <div className="px-[20px]">
          <div className="max-w-[1204px] mx-auto w-full pt-5 pb-[70px] rounded-[8px] overflow-hidden">
            <Link
              target="_blank"
              href="https://s3.amazonaws.com/rws-production-rws-rebate-forms/EEPLOCQF.pdf"
            >
              <Image src={FullSuitBannerWeb} alt="banner" className="md:hidden" />
              <Image src={FullSuitBannerMobile} alt="banner" className="hidden md:block" />
            </Link>
          </div>
        </div>
      ) : null}
      <Category brandName={brandTitle} />
      {brandTitle === "Bosch" && (
        <div className="bg-light-gray mb-[48px] lg:mb-[24px]">
          
        <div className="max-w-[1480px] mx-auto my-0 px-5 pb-[60px] lg:pb-7">
          <div className=" w-full  overflow-hidden flex gap-10 lg:gap-7 sm:flex-col ">
            <Link
              href="/shop?tag=bosch-induction-cookware-promotion"
              onClick={() => {
                updateBreadcrumb([
                  {
                    name: "BOSCH Induction Cookware Promotion",
                    url: `/shop?tag=bosch-induction-cookware-promotion`,
                  },
                ]);
              }}
            >
              <div className=" rounded-[20px] overflow-hidden ">
                <Image
                src={BoschBannerDesktop}
                alt="ad-banner"
                className=" sm:hidden"
              />
              <Image
                src={BoschBannerMobilep}
                alt="ad-banner"
                className=" hidden sm:block "
              />
              </div>
            </Link>
            <Link
              href="/coffee-systems?page=1&brandIds=20"
              onClick={() => {
                updateBreadcrumb([
                  {
                    name: "BOSCH Coffee Systems",
                    url: `/coffee-systems?page=1&brandIds=20`,
                  },
                ]);
              }}
            >
              <div className=" rounded-[20px] overflow-hidden ">
                <Image
                src={BoschEspressoMachineBannerDesktop}
                alt="ad-banner"
                className=" sm:hidden"
              />
              <Image
                src={BoschEspressoMachineBannerMobile}
                alt="ad-banner"
                className=" hidden sm:block "
              />
              </div>
            </Link>
          </div>
        </div>
        </div>
      )}


       {/* {["Electrolux"].includes(brandTitle) ? (
        <div className="px-[20px] md:px-0 pt-10 md:pt-0  max-w-[1024px] mx-auto w-full  rounded-[8px] overflow-hidden" >
            <botton onClick={scrollToContact} className=" cursor-pointer">
            
              <Image src={ElectroluxLaundryWeb} alt="banner" className="md:hidden" />
              <Image src={ElectroluxLaundryMobile} alt="banner" className="hidden md:block" />
          
          </botton>
        </div>
      ) : null} */}
      
      <VideoSection brandName={brandTitle} />
      
     

      {["Cove", "Sub_Zero", "Wolf"].includes(brandTitle) ? (
        <div className="px-[20px] bg-[#F5F5F7]">
        <div className="max-w-[1204px] mx-auto w-full pt-[64px] pb-[12px] rounded-[8px] overflow-hidden">
          <Link target="_blank" href="https://riggsdistributing.com/rebates/loyalty-programs/">
            <Image src={LoyaltyProgramWeb} alt="banner" className=" md:hidden "/>
            <Image src={LoyaltyProgramMobile} alt="banner" className=" hidden md:block "/>
          </Link>
        </div>
      </div> 
      ) : null}

      <FindShowroom brandName={brandTitle} />
      <div ref={contactRef} >
        <ContactSpecialist brandName={brandTitle} />
      </div>
      <SEOContent  brandName={slug} />
    </div>
  );
};

export default BrandDetail;